import { useOutletContext } from 'react-router'
import type { MockProfile, Occurrence } from '@/types/occurrence'

export interface OccurrenceContext {
	occ: Occurrence
	profile: MockProfile
	userName: string
	/** Pode editar dados comuns (perfil + estado da ocorrência) */
	editable: boolean
	/** Após validação, campos críticos ficam bloqueados */
	locked: boolean
}

export const useOccurrence = () => useOutletContext<OccurrenceContext>()
